// @flow
import React from 'react';
import { colors } from 'seedling/constants';
import type { IconProps } from './types';

export type RetriggerIconProps = IconProps & { color: string, title: string };

const RetriggerIcon = ({
  width,
  height,
  className,
  color,
  title,
}: RetriggerIconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 21 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path id="a" d="M0 .29h15.088233v9.6798H0z" />
      <path id="c" d="M.697018.3204H15.7626V10H.697018z" />
    </defs>

    <title>{title}</title>

    <g fill="none" fillRule="evenodd">
      <g transform="translate(0 .71)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          d="M14.8947 3.2598c-.279.3-.76.33-1.06.05-1.08-.98-2.48-1.52-3.929-1.52-3.031 0-5.54 2.321-5.83 5.27l1.21-1.21c.29-.3.759-.3 1.059 0 .29.29.29.77 0 1.06l-3.059 3.06-3.061-3.06c-.3-.29-.3-.77 0-1.06.29-.3.761-.3 1.061 0l1.29 1.29c.25-3.819 3.439-6.85 7.33-6.85 1.83 0 3.58.68 4.939 1.91.3.281.33.75.05 1.06"
          fill={color}
          mask="url(#b)"
        />
      </g>
      <g transform="translate(4 5.71)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <path
          d="M15.5451 4.4404c-.14.14-.34.22-.53.22s-.38-.08-.53-.22l-1.26-1.261c-.27 3.811-3.451 6.821-7.32 6.821-1.85 0-3.61-.691-4.97-1.93-.3-.28-.32-.75-.04-1.061.28-.309.75-.33 1.06-.049 1.08.99 2.48 1.54 3.95 1.54 3.03 0 5.54-2.331 5.82-5.3l-1.24 1.24c-.29.29-.77.29-1.06 0-.29-.301-.29-.771 0-1.061l3.06-3.059 3.06 3.059c.29.29.29.76 0 1.061"
          fill={color}
          mask="url(#d)"
        />
      </g>
    </g>
  </svg>
);

RetriggerIcon.defaultProps = {
  color: colors.mediumGrey,
  width: 20,
  height: 20,
  title: 'Retrigger',
};

export default RetriggerIcon;
